module.exports = __webpack_public_path__ + "img/Header.jpg";